(function(){
var el=document.getElementById('cd');if(!el)return;
var t=new Date(el.dataset.date).getTime();if(isNaN(t))return;
var d=el.querySelector('[data-d]'),h=el.querySelector('[data-h]'),m=el.querySelector('[data-m]'),s=el.querySelector('[data-s]'),msg=document.getElementById('open');
function set(e,v){if(e.textContent!==v){e.textContent=v;e.classList.remove('tk');void e.offsetWidth;e.classList.add('tk')}}
function p(n){return n<10?'0'+n:''+n}
function tick(){var x=t-Date.now();if(x<0)x=0;
 set(d,''+Math.floor(x/864e5));set(h,p(Math.floor(x%864e5/36e5)));set(m,p(Math.floor(x%36e5/6e4)));set(s,p(Math.floor(x%6e4/1e3)));
 if(x===0&&msg)msg.hidden=false;}
tick();setInterval(tick,1000);})();
(function(){
var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches;if(rm)return;
var tl=document.getElementById('tilt');
if(tl){var tx=0,ty=0,cx=0,cy=0;
 function mv(x,y){tx=(x/innerWidth-.5)*2;ty=(y/innerHeight-.5)*2}
 addEventListener('mousemove',function(e){mv(e.clientX,e.clientY)});
 addEventListener('touchmove',function(e){var t=e.touches[0];mv(t.clientX,t.clientY)},{passive:true});
 addEventListener('deviceorientation',function(e){if(e.gamma==null)return;tx=Math.max(-1,Math.min(1,e.gamma/30));ty=Math.max(-1,Math.min(1,(e.beta-45)/30))});
 (function loop(){cx+=(tx-cx)*.08;cy+=(ty-cy)*.08;tl.style.transform='rotateY('+(cx*16)+'deg) rotateX('+(-cy*12)+'deg)';requestAnimationFrame(loop)})();}
var cv=document.getElementById('fx');if(!cv)return;var g=cv.getContext('2d'),W,H,P=[],N=70,dpr=Math.min(devicePixelRatio||1,2);
function rs(){W=cv.clientWidth;H=cv.clientHeight;cv.width=W*dpr;cv.height=H*dpr;g.setTransform(dpr,0,0,dpr,0,0)}
function mk(r){return{x:Math.random()*W,y:r?Math.random()*H:H+10,z:Math.random()*.9+.1,v:Math.random()*.4+.15}}
rs();addEventListener('resize',rs);for(var i=0;i<N;i++)P.push(mk(true));
(function f(){g.clearRect(0,0,W,H);
 for(var i=0;i<N;i++){var q=P[i];q.y-=q.v*q.z*1.4;q.x+=Math.sin((q.y+i*40)/90)*.25;if(q.y<-10)P[i]=mk(false);
  g.globalAlpha=q.z*.55;g.fillStyle='#fff';g.beginPath();g.arc(q.x,q.y,q.z*1.8,0,6.283);g.fill();}
 requestAnimationFrame(f)})();
})();

(function(){
var pw=document.getElementById('pw'),ld=document.getElementById('ld');if(!pw||!ld)return;
function go(){pw.classList.remove('pre');setTimeout(function(){ld.remove()},1600)}
if(document.querySelector('.pwerr')){ld.remove();pw.classList.remove('pre');return}
var n=document.getElementById('ldn'),b=document.getElementById('ldb'),t0=performance.now(),D=2800,ready=document.readyState==='complete',done=false;
addEventListener('load',function(){ready=true});
(function f(now){var k=Math.min(1,(now-t0)/D),e=1-Math.pow(1-k,2.2),v=e*100;if(!ready&&v>92)v=92;
 n.textContent=Math.floor(v);b.style.width=v+'%';
 if(v>=100&&!done){done=true;ld.classList.add('fl');setTimeout(function(){ld.classList.add('out');setTimeout(go,350)},450);return}
 requestAnimationFrame(f)})(t0);
setTimeout(function(){ready=true},6000);
})();
